<template>
		<v-layout column>
			<v-flex xs12 lg6 offset-sm3>
					<div class="mapheader">
						<gmap-map :center="center" :zoom="17" style="width: 100%; height: 300px" >
						  <gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWinOpen" @closeclick="infoWinOpen=false">
							{{infoContent}}
						  </gmap-info-window>

						  <gmap-marker 
						  :key="i" 
						  v-for="(m,i) in markers" 
						  :position="m.position" 
						  :clickable="true" 
						  @click="toggleInfoWindow(m,i)"
						  :icon.sync="m.icon"
						  >
						  </gmap-marker>
						</gmap-map>
					</div>
					<div class="mapcontent">
					  <v-list>
						  <v-list-tile avatar v-for="item in items" v-bind:key="item.title" :to="item.link">
							<v-list-tile-avatar>
							  <img v-bind:src="item.avatar"/>
							</v-list-tile-avatar>
							<v-list-tile-content>
							  <v-list-tile-title v-html="item.title"></v-list-tile-title>
							</v-list-tile-content>
						  </v-list-tile>
					  </v-list>
					</div>
			</v-flex>
		</v-layout>
</template>
 
<script>
  import * as VueGoogleMaps from 'vue2-google-maps'
  import Vue from 'vue'
  Vue.use(VueGoogleMaps, {
    load: {
      key: 'AIzaSyDi8S0yBC6rcLTCgqxvRanYMMxT17CW14Y',
      v: '3.31'
      // libraries: 'places', //// If you need to use place input
    }
  })

  export default {
    data () {
      return {
        center: {lat: 19.029908, lng: 74.719005},
        infoContent: '',
        infoWindowPos: {
          lat: 0,
          lng: 0
        },
        infoWinOpen: false,
        currentMidx: null,
        infoOptions: {
          pixelOffset: {
            width: 0,
            height: -35
          }
        },
        items: [
          { title: '1. The Tomb-Shrine, Samadhi of Avatar Meher Baba', avatar: '/static/doc-images/lists/samahdiSacred.jpg', link: '/marker/The%20Tomb-Shrine,%20Samadhi%20of%20Avatar%20Meher%20Baba' },
          { title: '2. Meher Retreat', avatar: '/static/doc-images/lists/MeherRetreat.jpg', link: '/marker/Meher%20Retreat' },
          { title: '3. The Dhuni of Meherabad', avatar: '/static/doc-images/lists/dhuni.jpg', link: '/marker/The%20Dhuni%20of%20Meherabad' },
          { title: '4. The Original Well', avatar: '/static/doc-images/lists/Originalwell.jpg', link: '/marker/The%20Original%20Well' },
          { title: '5. The Main Bungalow (also known as Mandali Hall)', avatar: '/static/doc-images/lists/MainBungulaow.jpg', link: '/marker/The%20Main%20Bungalow%20(also%20known%20as%20Mandali%20Hall)' },
          { title: '6. The Tomb of Gilori Shah & The Neem Tree', avatar: '/static/doc-images/lists/GloriaShahTomb.jpg', link: '/marker/The%20Tomb%20of%20Gilori%20Shah%20&%20The%20Neem%20Tree' },
          { title: '7. The Rahuri Cabin', avatar: '/static/doc-images/lists/rahuricabin.jpg', link: '/marker/The%20Rahuri%20Cabin' },
          { title: '8. The Land', avatar: '/static/doc-images/lists/meherabadsign.jpg', link: '/marker/The%20Land' }
        ],
        markers: [{
          position: {lat: 19.030994, lng: 74.714059}, infoText: 'The Tomb-Shrine, Samadhi of Avatar Meher Baba', icon: '/static/doc-images/lists/loc/loc1.png'
        }, {
          position: {lat: 19.031159, lng: 74.714633}, infoText: 'Meher Retreat', icon: '/static/doc-images/lists/loc/loc2.png'
        }, {
          position: {lat: 19.029584, lng: 74.718436}, infoText: 'The Dhuni of Meherabad', icon: '/static/doc-images/lists/loc/loc3.png'
        }, {
          position: {lat: 19.029016, lng: 74.718350}, infoText: 'The Original Well', icon: '/static/doc-images/lists/loc/loc4.png'
        }, {
          position: {lat: 19.028651, lng: 74.719369}, infoText: 'The Main Bungalow (also known as Mandali Hall)', icon: '/static/doc-images/lists/loc/loc5.png'
        }, {
          position: {lat: 19.029163, lng: 74.718409}, infoText: 'The Tomb of Gilori Shah & The Neem Tree', icon: '/static/doc-images/lists/loc/loc6.png'
        }, {
          position: {lat: 19.030101, lng: 74.719225}, infoText: 'The Rahuri Cabin', icon: '/static/doc-images/lists/loc/loc7.png'
        }, {
          position: {lat: 19.029908, lng: 74.719015}, infoText: 'The Land', icon: '/static/doc-images/lists/loc/loc8.png'
        }]
      }
    },
    methods:
    {
      toggleInfoWindow: function (marker, idx) {
        this.infoWindowPos = marker.position
        this.infoContent = marker.infoText
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen
        } else {
          this.infoWinOpen = true
          this.currentMidx = idx
        }
        this.$router.push({name: 'marker', params: {infoText: marker.infoText}})
      }
    }
  }
</script>

<style>
.gm-iv-address-description {
    display: inline-block;
    min-width: 107px;
    max-width: 310px;
    vertical-align: top;
    position: relative;
    height: 44px;
    padding-right: 30px;
}
.mapheader
	{
		height:300px;
		position: absolute;
		top: 50px;
		left:0px;
		right:0px;
		bottom:0px;
	}
.mapcontent
	{
		position:absolute;
		top: 350px;
		left:0px;
		right:0px;
		bottom:0px;
		overflow-y:scroll;        
	}
</style>


// WEBPACK FOOTER //
// Historicsites.vue?5c9d229c